import { useCallback, useContext } from 'react';
import { BackendDispatchContext } from '../context/backend-context';

export const useProcessToken = () => {
  const { asyncActions } = useContext(BackendDispatchContext)

  return useCallback(async (token: string) => {
    return asyncActions?.processToken(token);
  }, [ asyncActions ])
}